/**
 * Stack nested modal locks: background stays non-scrollable until the last lock releases
 * (e.g. date modal inside table reservation). Use in useEffect: return beginModalBodyScrollLock() when open.
 */
let lockCount = 0;
let bodyOverflow = '';
let htmlOverflow = '';

const HTML_MODAL_CLASS = 'mw-widget-modal-open';
export const WIDGET_MODAL_LOCK_EVENT = 'meeteor:widget-modal-lock';

function dispatchModalOpen(open: boolean) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (open) {
    document.documentElement.classList.add(HTML_MODAL_CLASS);
  } else {
    document.documentElement.classList.remove(HTML_MODAL_CLASS);
  }
  window.dispatchEvent(new CustomEvent(WIDGET_MODAL_LOCK_EVENT, { detail: { open } }));
}

export function beginModalBodyScrollLock(): () => void {
  if (typeof document === 'undefined') {
    return () => {};
  }
  if (lockCount++ === 0) {
    bodyOverflow = document.body.style.overflow;
    htmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    dispatchModalOpen(true);
  }
  return function releaseModalBodyScrollLock() {
    if (--lockCount <= 0) {
      lockCount = 0;
      document.body.style.overflow = bodyOverflow;
      document.documentElement.style.overflow = htmlOverflow;
      dispatchModalOpen(false);
    }
  };
}
